import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './AuthCallback.css';

const AuthCallback = () => {
  const { loading, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // El AuthContext ya maneja el callback automáticamente
    // Solo necesitamos redirigir después de un tiempo
    if (!loading && !error) {
      // Redirigir a la página principal después del login exitoso
      navigate('/', { replace: true });
    } else if (error) {
      // Redirigir a login si hay error
      navigate('/login', { replace: true });
    }
  }, [loading, error, navigate]);

  if (loading) {
    return (
      <div className="auth-callback">
        <div className="auth-loading-container">
          <div className="auth-loading-card">
            <div className="auth-loading-icon">
              <div className="auth-spinner"></div>
            </div>
            <h2 className="auth-loading-title">Procesando autenticación...</h2>
            <p className="auth-loading-message">Por favor espera mientras verificamos tu cuenta.</p>
            <div className="auth-loading-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="auth-callback">
        <div className="error-container">
          <h2>Error de autenticación</h2>
          <p>{error}</p>
          <button onClick={() => navigate('/login')}>
            Volver al login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-callback">
      <div className="success-container">
        <h2>¡Autenticación exitosa!</h2>
        <p>Redirigiendo...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
